export function useScanBarcodes() {
  return [() => {}, []];
}
